import React from 'react';
import {Icon, IconTypes} from '../Buttons';

const EditOptions = ({disabled, onClick}) => {
    return <Icon type={IconTypes.edit} disabled={disabled} onClick={onClick}/>;
}

export default EditOptions;


// WEBPACK FOOTER //
// ./src/components/EditOptions/index.js